import React from 'react';
import { X, XCircle, AlertTriangle } from 'lucide-react';

// Map internal error keys to human-readable labels
const formatErrorKey = (key) => {
    if (key.startsWith('part_')) return `Part ${parseInt(key.split('_')[1]) + 1} Details`;
    if (key.startsWith('labor_')) return `Labor Op ${parseInt(key.split('_')[1]) + 1} Details`;
    const map = {
        VIN: 'VIN',
        ModelName: 'Model Name',
        ModelCode: 'Vehicle Model',
        CustomerName: 'Customer Name',
        EstimatedAmount: 'Estimated Total Amount',
        PartsUsed: 'Parts Used (At least one required)',
        LaborOpDetails: 'Labor Operations (At least one required)'
    };
    return map[key] || key;
};

// Lists the required fields that are still missing.
const ValidationModal = ({ isOpen, onClose, errors }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-primary bg-opacity-80 backdrop-blur-sm flex justify-center items-center z-50" onClick={onClose}>
            <div className="bg-surface rounded-none border-t-4 border-red-600 border-x border-b border-line w-full max-w-lg mx-4 flex flex-col shadow-2xl" onClick={e => e.stopPropagation()}>
                <header className="flex justify-between items-center p-6 border-b border-line bg-background">
                    <div className="flex items-center space-x-4">
                        <AlertTriangle className="h-6 w-6 text-red-600" />
                        <h5 className="text-sm font-semibold text-red-600 uppercase tracking-widest">Required Fields Missing</h5>
                    </div>
                    <button onClick={onClose} className="p-2 text-text-muted hover:text-text-main transition-colors">
                        <X className="h-5 w-5" />
                    </button>
                </header>
                <div className="p-8 max-h-[60vh] overflow-y-auto">
                    <p className="text-xs font-semibold text-text-main mb-6 uppercase tracking-wider">Please provide information for the following fields to proceed:</p>
                    <ul className="space-y-3">
                        {Object.entries(errors).map(([key, msg]) => (
                            <li key={key} className="flex items-start space-x-3 text-sm text-text-main bg-red-50 p-3 border-l-2 border-red-600">
                                <XCircle className="h-4 w-4 text-red-600 shrink-0 mt-0.5" />
                                <span className="font-semibold tracking-wide uppercase text-xs mt-0.5">{formatErrorKey(key)}</span>
                            </li>
                        ))}
                    </ul>
                </div>
                <footer className="p-6 border-t border-line bg-background flex justify-end">
                    <button onClick={onClose} className="bg-red-600 hover:bg-red-700 text-white py-3 px-8 text-xs uppercase tracking-widest font-semibold transition-colors rounded-none">
                        Review Form
                    </button>
                </footer>
            </div>
        </div>
    );
};

export default ValidationModal;
